import { createCustomEnum } from "./customEnum";

const DealNotesAgentCategoriesTypes = createCustomEnum({
	AgentRelationsAgent: {
		name: "agent_relations_agent",
		value: 5,
		displayName: "Agent Relations/ Agent",
	},
	Collections: {
		name: "collections",
		value: 2,
		displayName: "Collections",
	},
	Compliance: {
		name: "compliance",
		value: 3,
		displayName: "Compliance",
	},
	CustomerService: {
		name: "customer_service",
		value: 0,
		displayName: "Customer Service",
	},
	Other: {
		name: "other",
		value: 6,
		displayName: "Other",
	},
	Risk: {
		name: "risk",
		value: 4,
		displayName: "Risk",
	},
	Sales: {
		name: "sales",
		value: 7,
		displayName: "Sales",
	},
	TechnicalSupport: {
		name: "technical_support",
		value: 1,
		displayName: "Technical Support",
	},
});

export default DealNotesAgentCategoriesTypes;
